import { CardElementName } from "../../../models/CardElement";
import { CardVariant } from "../../../models/CardVariant";
import { IFilterCommand } from "../IFilterCommand";

export type ElementFilterArgs = {
    elements: CardElementName[],
    isAnd: boolean
}

export class ElementFilter<TItem extends CardVariant> implements IFilterCommand<TItem, ElementFilterArgs> {
    isMatch(item: TItem, args: ElementFilterArgs = { elements: [], isAnd: false }): boolean {
        // Should start as false for Any and start as true for other match methods.
        let isElementMatch = args.isAnd;

        if (!args.elements.length) {
            return true;
        }

        const cardElements = item?.card?.elements;

        if (!cardElements?.length) {
            return false;
        }

        if (args.isAnd) {
            for (const element of args.elements) {
                isElementMatch = isElementMatch && cardElements.some(x => x === element);
            }
        } else {
            for (const element of args.elements) {
                isElementMatch = isElementMatch || cardElements.some(x => x === element);
            }
        }

        return isElementMatch;
    }
}